// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const BASE_URL =
//   "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller";

// // ─── List Panel ────────────────────────────────────────────────────────────────
// export const HomeDescriptionPanel = () => {
//   const [DescriptionData, setDescriptionData] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.post(`${BASE_URL}/list_description`);
//         setDescriptionData(response.data.data);
//       } catch (error) {
//         console.error("There was an error!", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const deleteDescription = async (descId) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/delete_description`,
//         { id: descId },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (response.data.success === "1" || response.data.success === 1) {
//         setDescriptionData((prev) => prev.filter((item) => item.id !== descId));
//         toast.error("Data Deleted Successfully!");
//       } else {
//         toast.error(response.data.error || "Delete failed.");
//       }
//     } catch (error) {
//       console.error("There was an error!", error);
//     }
//   };

//   return (
//     <div className="container mt-5">
//       <div className="add-btn mb-3">
//         <Link to="/Master/HomeDescription-add">
//           <button className="btn btn-success text-white">
//             Add Description
//           </button>
//         </Link>
//       </div>

//       <table className="table table-bordered table-striped">
//         <thead>
//           <tr>
//             <th
//               colSpan="3"
//               className="text-center bg-white fs-4 text-black"
//             >
//               Home Description Table
//             </th>
//           </tr>
//           <tr>
//             <th
//               style={{ width: "10%" }}
//               className="text-white text-center table-custom"
//             >
//               #
//             </th>
//             <th
//               style={{ width: "70%" }}
//               className="text-white text-center table-custom"
//             >
//               Description
//             </th>
//             <th
//               style={{ width: "20%" }}
//               className="text-white text-center table-custom"
//             >
//               Actions
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {DescriptionData.map((Data, index) => (
//             <tr key={Data.id}>
//               <td className="text-center">{index + 1}</td>
//               <td>{Data.description}</td>
//               <td className="text-center">
//                 <Link to={`/Master/HomeDescription-edit/${Data.id}`}>
//                   <button className="btn btn-primary btn-sm me-1">
//                     <i className="fa-regular fa-pen-to-square text-white"></i>
//                   </button>
//                 </Link>
//                 <button
//                   className="btn btn-danger btn-sm me-1"
//                   onClick={() => deleteDescription(Data.id)}
//                 >
//                   <i className="fa-regular fa-trash-can text-white"></i>
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// // ─── Add ───────────────────────────────────────────────────────────────────────
// export const HomeDescriptionAdd = () => {
//   const [descriptionUser, setDescriptionUser] = useState({
//     description: "",
//   });
//   const navigate = useNavigate();

//   const inputHandler = (e) => {
//     const { name, value } = e.target;
//     setDescriptionUser({ ...descriptionUser, [name]: value });
//   };

//   const submitForm = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/add_description`,
//         descriptionUser
//       );

//       if (response.data.success === "1" || response.data.success === 1) {
//         navigate("/Master/HomeDescription");
//         toast.success(response.data.message || "Data Added successfully!");
//       } else {
//         toast.error(response.data.error || "Failed to add Description");
//       }
//     } catch (error) {
//       console.error("There was an error!", error);
//     }
//   };

//   return (
//     <div className="container mt-5">
//       <div className="card shadow-sm">
//         <div className="card-header table-custom text-white">
//           <h4 className="mb-0 text-white text-center">Add Home Description</h4>
//         </div>

//         <div className="card-body">
//           <form className="row g-3" onSubmit={submitForm}>
//             <div className="col-md-6">
//               <label htmlFor="description" className="form-label">
//                 Description
//               </label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="description"
//                 name="description"
//                 placeholder="Enter Description"
//                 value={descriptionUser.description}
//                 onChange={inputHandler}
//               />
//             </div>

//             <div className="col-12 d-flex justify-content-end">
//               <button
//                 type="submit"
//                 className="btn btn-success"
//                 style={{ height: "40px" }}
//               >
//                 Add Description
//               </button>
//               <div className="mb-3 ms-2">
//                 <Link to="/HomeDescription" className="btn btn-secondary">
//                   Back
//                 </Link>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Edit ──────────────────────────────────────────────────────────────────────
// export const EditHomeDescription = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [descriptionData, setDescriptionData] = useState({
//     description: "",
//   });

//   useEffect(() => {
//     const fetchDescription = async () => {
//       try {
//         const response = await axios.post(
//           `${BASE_URL}/get_description_by_id`,
//           { id: id }
//         );
//         setDescriptionData(response.data.data);
//       } catch (error) {
//         console.error("Fetch Error:", error);
//         toast.error("Something went wrong while fetching data.");
//       }
//     };

//     if (id) fetchDescription();
//   }, [id]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(`${BASE_URL}/update_description`, {
//         id: id,
//         description: descriptionData.description,
//       });

//       if (response.data.success === "1" || response.data.success === 1) {
//         toast.success("Description updated successfully!");
//         navigate("/Master/HomeDescription");
//       } else {
//         toast.error("Failed to update description");
//       }
//     } catch (error) {
//       console.error("Update Error:", error);
//       toast.error("Something went wrong while updating.");
//     }
//   };

//   return (
//     <div
//       className="modal fade show"
//       id="update_description"
//       tabIndex={-1}
//       role="dialog"
//       style={{
//         display: "block",
//         paddingRight: 18,
//         marginTop: 90,
//         paddingBottom: 50,
//       }}
//       aria-modal="true"
//     >
//       <div className="modal-dialog" role="document">
//         <form onSubmit={handleSubmit}>
//           <div className="modal-content">
//             <div className="modal-header justify-content-center table-custom">
//               <h5 className="modal-title text-white">Edit Description</h5>
//             </div>

//             <div className="modal-body">
//               <div className="form-group">
//                 <label>Description</label>
//                 <textarea
//                   value={descriptionData.description}
//                   onChange={(e) =>
//                     setDescriptionData({
//                       ...descriptionData,
//                       description: e.target.value,
//                     })
//                   }
//                   className="form-control"
//                   name="description"
//                   id="description"
//                   rows={4}
//                 />
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button type="submit" className="btn btn-success">
//                 Update
//               </button>
//               <Link to="/HomeDescription">
//                 <button type="button" className="btn btn-secondary">
//                   Close
//                 </button>
//               </Link>
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const BASE_URL =
  "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller";

// ─── List Panel ────────────────────────────────────────────────────────────────
export const HomeDescriptionPanel = () => {
  const [DescriptionData, setDescriptionData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/list_description`);
        const reverselist = response.data.data.reverse()
        setDescriptionData(reverselist);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    fetchData();
  }, []);

  const deleteDescription = async (descId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/delete_description`,
        { id: descId },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success === "1" || response.data.success === 1) {
        setDescriptionData((prev) => prev.filter((item) => item.id !== descId));
        toast.error("Data Deleted Successfully!");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="add-btn mb-3">
        <Link to="/Master/HomeDescription-add">
          <button className="btn btn-success text-white">
            Add Description
          </button>
        </Link>
      </div>

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th
              colSpan="3"
              className="text-center bg-white fs-4 text-black"
            >
              Home Description Table
            </th>
          </tr>
          <tr>
            <th
              style={{ width: "10%" }}
              className="text-white text-center table-custom"
            >
              #
            </th>
            <th
              style={{ width: "70%" }}
              className="text-white text-center table-custom"
            >
              Description
            </th>
            <th
              style={{ width: "20%" }}
              className="text-white text-center table-custom"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {DescriptionData.map((Data, index) => (
            <tr key={Data.id}>
              <td className="text-center">{index + 1}</td>
              {/* Renders the CKEditor HTML content (links, formatting, etc.) */}
              <td dangerouslySetInnerHTML={{ __html: Data.description }} />
              <td className="text-center">
                <Link to={`/Master/HomeDescription-edit/${Data.id}`}>
                  <button className="btn btn-primary btn-sm me-1">
                    <i className="fa-regular fa-pen-to-square text-white"></i>
                  </button>
                </Link>
                <button
                  className="btn btn-danger btn-sm me-1"
                  onClick={() => deleteDescription(Data.id)}
                >
                  <i className="fa-regular fa-trash-can text-white"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ─── Add ───────────────────────────────────────────────────────────────────────
export const HomeDescriptionAdd = () => {
  const [descriptionUser, setDescriptionUser] = useState({
    description: "",
  });
  const navigate = useNavigate();

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${BASE_URL}/add_description`,
        descriptionUser
      );

      if (response.data.success === "1" || response.data.success === 1) {
        navigate("/Master/HomeDescription");
        toast.success(response.data.message || "Data Added successfully!");
      } else {
        toast.error(response.data.error || "Failed to add Description");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header table-custom text-white">
          <h4 className="mb-0 text-white text-center">Add Home Description</h4>
        </div>

        <div className="card-body">
          <form className="row g-3" onSubmit={submitForm}>
            <div className="col-md-12">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <CKEditor
                editor={ClassicEditor}
                data={descriptionUser.description}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescriptionUser({ ...descriptionUser, description: data });
                }}
              />
            </div>

            <div className="col-12 d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-success"
                style={{ height: "40px" }}
              >
                Add Description
              </button>
              <div className="mb-3 ms-2">
                <Link to="/HomeDescription" className="btn btn-secondary">
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// ─── Edit ──────────────────────────────────────────────────────────────────────
export const EditHomeDescription = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [descriptionData, setDescriptionData] = useState({
    description: "",
  });

  useEffect(() => {
    const fetchDescription = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/get_description_by_id`,
          { id: id }
        );
        setDescriptionData(response.data.data);
      } catch (error) {
        console.error("Fetch Error:", error);
        toast.error("Something went wrong while fetching data.");
      }
    };

    if (id) fetchDescription();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${BASE_URL}/update_description`, {
        id: id,
        description: descriptionData.description,
      });

      if (response.data.success === "1" || response.data.success === 1) {
        toast.success("Description updated successfully!");
        navigate("/Master/HomeDescription");
      } else {
        toast.error("Failed to update description");
      }
    } catch (error) {
      console.error("Update Error:", error);
      toast.error("Something went wrong while updating.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_description"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={handleSubmit}>
          <div className="modal-content">
            <div className="modal-header justify-content-center table-custom">
              <h5 className="modal-title text-white">Edit Description</h5>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Description</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={descriptionData.description}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setDescriptionData({
                      ...descriptionData,
                      description: data,
                    });
                  }}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/HomeDescription">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};